import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useInstructorPendingReviews — GET /api/instructor/interview-sim/pending
 * Returns list of sessions awaiting instructor review.
 *
 * @param {object} options
 * @param {boolean} [options.enabled=true] — false olursa istek HİÇ atılmaz;
 *   reviews boş dizi, loading false döner. Öğrenci rotalarında 401 gürültüsünü önler.
 */
export function useInstructorPendingReviews({ enabled = true } = {}) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  const fetchReviews = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const res = await axios.get(`${API}/instructor/interview-sim/pending`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setReviews(Array.isArray(res.data) ? res.data : (res.data?.sessions || []));
    } catch (err) {
      setError(err?.response?.data?.message_tr || err?.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setReviews([]);
      setLoading(false);
      setError(null);
      return;
    }
    fetchReviews();
  }, [enabled, fetchReviews]);

  return { reviews, loading, error, refetch: fetchReviews };
}
